<template>
	<div :class="($route.path === '/checkout')?'col-12 p-0':'col p-0'">
		<form data-vv-scope="internalBankAccount" @submit.prevent="action('internalBankAccount')">
		<div class="form-group mt-3 width-reduce-large-device">
			<label for="bank-account-payment-method-account-chooser" id="vendor-signup-country-heading">
				Choose Your Account
				<span class="asteriskField">*</span>
			</label>
			<select
				@change="$forceUpdate()"
				class="custom-select d-block w-100"
				id="bank-account-payment-method-account-chooser"
				name="bankAccountPaymentAccountChooser"
				v-validate="{ required: true }"
				v-model="selectedAccount"
				:class="((showInternalBankSelectionError && selectedAccount === 'Select...') || errors.has('internalBankAccount.bankAccountPaymentAccountChooser'))?'is-invalid':''"
			>
				<option disabled>Select...</option>
				<option
					v-for="(accountNumber,index) in this.getUserData.account_numbers"
					:key="index"
					:id="'country'+index"
				>
					{{accountNumber}}
				</option>
			</select>
			<div
				class="invalid-feedback"
				v-if="((showInternalBankSelectionError && selectedAccount === 'Select...') || errors.has('internalBankAccount.bankAccountPaymentAccountChooser'))"
				id="internalBankAccount-select-error"
			>Please select an account to proceed</div>
		</div>
		<button
			id="bank-internal-account-payment-proceed-button"
			class="btn btn-primary blue-btn mx-auto"
			type="submit"
			data-test="bankPayBtn"
		>
			Proceed to Pay
		</button>
		</form>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { store } from '../../../../store/store'
import { orderApi } from '../../../../services/ApiServices/orderApi'
export default {
	name: 'bank-internal-account',
	computed: {
		...mapGetters('user', ['getUserData'])
	},
	data () {
		return {
			selectedAccount: 'Select...',
			showInternalBankSelectionError: false
		}
	},
	methods: {
		action (scope) {
			this.$validator.validateAll(scope).then(result => {
				if (result && this.selectedAccount !== 'Select...') {
					this.showInternalBankSelectionError = false
					this.internalBankPay()
				} else {
					this.showInternalBankSelectionError = true
				}
			})
		},
		internalBankPay () {
			this.$dialog
				.confirm('Please confirm to pay using Your Bank Account ')
				.then((dialog) => {
					orderApi.orderCharge('INT_ACC', '', this.selectedAccount)
						.then(() => {
							this.$router.push({
								path: '/order-success',
								query: {
									order_number: store.getters['user/getOrderData'].order_number,
									payment_mode: 'card'
								}
							})
						})
				})
				.catch(() => {
					// console.log('Clicked on cancel')
				})
		}
	},
	props: {
		gatewayId: {
			type: String,
			default: ''
		}
	}
}
</script>

<style scoped>

</style>
